<script lang="ts" setup>
import {ExtendedUser, NavigationItem} from "@/types";
import {useDisplay} from "vuetify";
import SettingsSidebar from "@/Pages/settings/layouts/components/SettingsSidebar.vue";
import {useUserAvatar} from "@/composables/avatar";

interface Props {
    user: ExtendedUser,
}

const props = defineProps<Props>()

const { smAndDown, mdAndUp } = useDisplay()

const items: Array<NavigationItem> = [
    {
        route: 'settings.profile.show',
        label: 'Public profile',
        icon: 'mdi-account-outline',
    },
    {
        route: 'settings.account.show',
        label: 'Account',
        icon: 'mdi-cog-outline',
    },
    {
        label: 'Access',
    },
    {
        route: 'settings.emails.index',
        label: 'Emails',
        icon: 'mdi-email-outline',
    },
    {
        route: 'settings.authentication',
        label: 'Password and authentication',
        icon: 'mdi-shield-lock-outline',
    },
    {
        route: 'settings.sessions.index',
        label: 'Sessions',
        icon: 'mdi-antenna',
    },
    {
        route: 'settings.keys.index',
        label: 'SSH and PGP keys',
        icon: 'mdi-key-outline',
    },
]
</script>

<template>
    <v-navigation-drawer
        :absolute="true"
        :sticky="true"
        class="pl-5 border-e-0 pt-5 pr-2"
        mobile-breakpoint="md"
        :width="mdAndUp ? 320 : undefined"
    >
        <v-list-item class="mb-3">
            <template #prepend>
                <v-avatar
                    size="54"
                    rounded="circle"
                    class="border-sm"
                >
                    <v-img
                        :src="useUserAvatar(props.user.name)"
                        contain
                    />
                </v-avatar>
            </template>
            <v-list-item-title />
            <template #title>
                <span class="text-h6 font-weight-bold">
                    {{ props.user.full_name }}
                </span>
                <span class="text-h6 font-weight-bold text-grey-darken-2">
                    ({{ props.user.name }})
                </span>
            </template>
            <template #subtitle>
                <span class="text-body-2 text-black">
                    Your personal account
                </span>
            </template>
        </v-list-item>
        <settings-sidebar
            :items="items"
        />
    </v-navigation-drawer>
    <v-row class="fill-height mx-3 mx-md-0 mb-15 pb-15">
        <v-col
            cols="12"
            lg="10"
        >
            <v-list-item
                v-if="smAndDown"
                class="my-3"
            >
                <template #prepend>
                    <v-avatar
                        size="54"
                        rounded="circle"
                        class="border-sm"
                    >
                        <v-img
                            :src="useUserAvatar(props.user.name)"
                            contain
                        />
                    </v-avatar>
                </template>
                <v-list-item-title />
                <template #title>
                    <span class="text-h6 font-weight-bold">
                        {{ props.user.full_name }}
                    </span>
                    <span class="text-h6 font-weight-bold text-grey-darken-2">
                        ({{ props.user.name }})
                    </span>
                </template>
                <template #subtitle>
                    <span class="text-body-2 text-black">
                        Your personal account
                    </span>
                </template>
            </v-list-item>
            <settings-sidebar
                v-if="smAndDown"
                :items="items"
            />
            <slot />
        </v-col>
    </v-row>
</template>

<style scoped>
</style>
